import { isNetworkError } from "@/Helpers/isNetworkError";
import { useOnce } from "@/Hooks/useOnce";
import { useTrackingService } from "@/Services/TrackingService";
import type { Document } from "@freightsimple/generated-dashboard-openapi-client/models/Document";
import { useState } from "react";

// Loads the documents listed on the public tracking page.
export function useTrackingDocuments(trId: string): Document[] {
  const { getDocumentsForTracking } = useTrackingService();
  const [documents, setDocuments] = useState<Document[]>([]);

  // With no answer from the API at all, the documents list stays as it is.
  // Any other failure is rethrown so it still reaches Sentry.
  useOnce(async () => {
    try {
      setDocuments(await getDocumentsForTracking(trId));
    } catch (error) {
      if (isNetworkError(error)) {
        console.warn("Could not load tracking documents", { error });
        return;
      }
      throw error;
    }
  });

  return documents;
}
